<template>
    <div class="state-list">
        <my-tag :type="item.type" @click="item.click" class="state-list">{{item.text}}</my-tag>

        <my-dialog 
        v-model="dialogVisible"
        :title="dialogTitle"
        >
            <component 
                v-if="dialogVisible" 
                :is="dialogComponent"
                @cancle="dialogClose"
                :row="row"
                :model="model"
            ></component>
        </my-dialog>
    </div>
</template>

<script>

export default {
    components: {},
    props: {
        row: {
            type: Object,
            default: () => ({})
        },
        model: {
           type: Object,
           default: () => ({})
       },
        config: {
            type: Array,
            default: () => ([])
        }
    },
    data: () => ({
        dialogVisible: false,
        dialogTitle: '',
        dialogComponent: 'span'
    }),
    watch: {
        dialogVisible(n) {
            if(!n) {
                this.$emit('reload');
            }
        }
    },
    computed: {
        item() {
            return this.config.filter(item => {
                return item.show(this.row, this.model);
            }).map(item => ({
                type: item.type,
                text: getType(item.text) === 'function' ? item.text(this.row, this.model) : item.text,
                click: getType(item.click) === 'function' ? item.click.bind(this) : () => {}
            }))[0] || {
                type: 'info',
                text: '无',
                click: ()=>{}
            };
        }
    },
    methods: {
        dialogOpen(component, title = '') {
            this.dialogComponent = component;
            this.dialogTitle = title;
            this.dialogVisible = true;
        },
        dialogClose() {
            this.dialogVisible = false;
        }
    }
}
</script>

<style scoped lang="scss">
.state-list{cursor:pointer;}
</style>
